import React from 'react';
import { advantages } from '../mock';
import * as Icons from 'lucide-react';

export const Advantages = () => {
  // Couleurs vibrantes et chaleureuses - SANS icônes check beige
  const iconStyles = [
    { bg: 'bg-gradient-to-br from-[#0A2320] to-[#1a4a45]', shadow: 'shadow-[#0A2320]/30' },
    { bg: 'bg-gradient-to-br from-[#D4AF37] to-[#e6c555]', shadow: 'shadow-[#D4AF37]/30' },
    { bg: 'bg-gradient-to-br from-[#0A2320] to-[#153254]', shadow: 'shadow-[#153254]/30' },
    { bg: 'bg-gradient-to-br from-[#D4AF37] to-[#c9a030]', shadow: 'shadow-[#D4AF37]/30' }
  ];

  return (
    <section id="avantages" className="py-20 md:py-24 bg-[#F8FAF9] font-['Poppins']">
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-[#153254]">
            Pourquoi nous choisir ?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Des engagements concrets pour votre tranquillité
          </p>
        </div>

        {/* Grille des avantages - SANS icônes check */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {advantages.map((advantage, index) => {
            const IconComponent = Icons[advantage.icon];
            const style = iconStyles[index % iconStyles.length];
            return (
              <div 
                key={advantage.id} 
                className="text-center group"
              >
                {/* Icône principale avec gradient - PAS de check */}
                <div className={`w-20 h-20 mx-auto mb-5 ${style.bg} rounded-2xl flex items-center justify-center shadow-xl ${style.shadow} group-hover:scale-110 group-hover:rotate-3 transition-all duration-300`}>
                  {IconComponent && <IconComponent className="h-10 w-10 text-white" strokeWidth={1.5} />}
                </div>
                <h3 className="font-bold text-lg mb-2 text-[#153254]">{advantage.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{advantage.description}</p>
              </div>
            );
          })}
        </div>

        {/* Bloc "Professionnels sélectionnés" */}
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-10 max-w-5xl mx-auto border border-gray-100">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0">
              <div className="w-24 h-24 bg-gradient-to-br from-[#0A2320] to-[#153254] rounded-2xl flex items-center justify-center shadow-xl">
                <Icons.Users className="h-12 w-12 text-white" strokeWidth={1.5} />
              </div>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl md:text-3xl font-bold mb-3 text-[#153254]">
                Des professionnels sélectionnés et formés
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Nos intervenants sont sélectionnés avec le plus grand soin. 
                Tous bénéficient d'une formation continue au cœur du savoir-faire The Majordhome. 
                Leur mission ? <span className="font-bold text-[#0A2320]">Votre satisfaction !</span>
              </p>
            </div>
          </div>
        </div>

        {/* Image inspirante - Bien-être et sérénité */}
        <div className="mt-14 max-w-5xl mx-auto">
          <div className="relative rounded-3xl overflow-hidden shadow-xl">
            <img 
              src="https://images.unsplash.com/photo-1545205597-3d9d02c29597?w=1200&q=80" 
              alt="Personne relaxée profitant de son temps libre"
              className="w-full h-72 md:h-96 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0A2320]/80 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-8 md:p-10 text-white max-w-xl">
              <p className="text-2xl md:text-3xl font-medium leading-relaxed">
                "Le temps retrouvé, la sérénité assurée"
              </p>
              <p className="mt-3 text-white/80 text-sm">
                Profitez enfin de moments précieux avec vos proches
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
